import { ISite } from '@metservicedev/platforms-services-interface/src/services/movSites/MovSitesV2Model';
import moment from 'moment-timezone';
import React from 'react';

import LoadingSpinner from '../../components/LoadingSpinner';
import contrastYIQ from '../../utils/contrastYIQ';
import { IWidgetBlockComponent } from '../types/IWidgetBlock';
import { Container, StyleHeaderImg } from './Header.style';
import { HeaderModel, HeaderSettings } from './types';

const getSiteDescription = (site: ISite, settings: HeaderSettings) => {
    const [lon, lat] = Array.isArray(site.coordinates) ? site.coordinates : [site.coordinates.lon, site.coordinates.lat];
    let siteLat = lat.toFixed(3);
    let siteLon = lon.toFixed(3);

    if (settings.showCardinalDirections) {
        siteLat = lat < 0 ? `${(-siteLat).toFixed(3)}S` : `${siteLat}N`;
        siteLon = lon < 0 ? `${(-siteLon).toFixed(3)}W` : `${siteLon}E`;
    }

    return (
        <span>
            {site.name} - {site.geoHashId} <br />({siteLat}, {siteLon})
        </span>
    );
};

const Header: React.FC<IWidgetBlockComponent<HeaderModel>> = ({ widgetModel }) => {
    if (!widgetModel) {
        return <LoadingSpinner />;
    }

    const {
        site,
        time,
        settings,
        settings: { fontSize, fontColor, fontWeight, showReportTime, image, heading },
    } = widgetModel;

    const headingText = heading || '';
    const momentTime = time ? moment(time.iso8601).tz(time.timezone) : null;

    const backgroundColor = settings.backgroundColor || '#16161d';
    const headerStyles = {
        fontSize: fontSize || 100,
        fontColor: fontColor || contrastYIQ(backgroundColor),
        fontWeight: fontWeight || 'normal',
        backgroundColor,
        styleSiteTextAlign: image || showReportTime ? 'center' : 'right',
        styleShowReportTextAlign: image ? 'left' : 'right',
    };

    return (
        <Container {...headerStyles}>
            <div className='wrapper'>
                <h1 className='header-h flex-1'>{headingText}</h1>

                {site && <div className='flex-1 site'>{getSiteDescription(site, settings)}</div>}

                {showReportTime && momentTime && <div className='flex-1 show-report'>{`Issued ${momentTime.format('lll')} ${momentTime.format('z')}`}</div>}

                {image && (
                    <StyleHeaderImg>
                        <img className='flex-1' src={image} />
                    </StyleHeaderImg>
                )}
            </div>
        </Container>
    );
};

export default Header;
